module.exports = __webpack_public_path__ + "media/images/member_follow-02013f9c7c41bdb90ea39d8c0c06bebb.svg";